import React from "react";
import Design from "./components/Design";
import PlusButton from "../../../../component/common/PlusButton";
import MinusButton from "../../../../component/common/MinusButton";
import Inventory from "./components/Inventory";
import Couch from "./components/Couch";
import Tabel from "./components/Tabel";

function Seating() {
  return (
    <>
      <div className="mt-3 p-3 bg-white">
        <div className="flex justify-between items-center">
          <div className="flex gap-5 items-center">
            <h3 className="text-blue font-semibold text-lg">
              AJ Ballroom Section 2
            </h3>
            <p className="text-sm font-normal">
              Seats added: <span className="font-medium">220/450</span>
            </p>
          </div>
          <button className="gradian-btn text-white px-3 py-2">
            Save & Proceed
          </button>
        </div>
        <div className="row">
          <div className="col-lg-3 d-none d-lg-block">
            <div className="bg-[#f0f2f7] rounded-2 p-3">
              <p className="text-[#1A2870] text-sm">Inventory</p>
              <div>
                <Inventory
                  label={"Tabel 1"}
                  table={<Tabel />}
                  capacity={1}
                  venu_capacity={5}
                />
              </div>
              <div>
                <Inventory
                  label={"Chair"}
                  table={<Design size={50} chairs={8} chairSize={8} />}
                  capacity={1}
                  venu_capacity={400}
                />
              </div>
              <div>
                <Inventory
                  label={"Couch"}
                  table={<Couch size={20} chairs={8} chairSize={5} />}
                  capacity={3}
                  venu_capacity={20}
                />
              </div>
              <div>
                <Inventory
                  label={"Tabel 1"}
                  table={<Design size={60} chairs={4} chairSize={10} />}
                  capacity={4}
                  venu_capacity={5}
                />
              </div>
              <div>
                <Inventory
                  label={"Tabel 1"}
                  table={<Design size={60} chairs={8} chairSize={10} />}
                  capacity={4}
                  venu_capacity={5}
                />
              </div>
              <div>
                <Inventory
                  label={"Tabel 1"}
                  table={<Design size={60} chairs={5} chairSize={10} />}
                  capacity={4}
                  venu_capacity={5}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-9  px-lg-5 bg-[#f0f2f7]">
            <div className=" p-3 flex flex-wrap gap-16  ">
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Design size={100} chairs={8} chairSize={13} />
              <Couch size={55} chairs={8} chairSize={8} />
              <Couch size={55} chairs={8} chairSize={8} />
              <Couch size={55} chairs={8} chairSize={8} />
              <div className="flex justify-between w-full">
                <div className="flex flex-column gap-5">
                  <Design size={100} chairs={8} chairSize={13} />
                  <Design size={100} chairs={8} chairSize={13} />
                </div>
                <div className="stage flex-1  shadow-lg border ">
                  <p className="text-center  h-full my-auto">stage</p>
                </div>
                <div className="flex flex-column gap-5">
                  <Design size={100} chairs={8} chairSize={13} />
                  <Design size={100} chairs={8} chairSize={13} />
                </div>
              </div>
            </div>
            <div className="mt-3">
              <h3 className="text-sm font-medium pb-3 text-[#1A2870]">Added</h3>
              <div className="row row-cols-lg-3 row-cols-2 bg-white py-3">
                <div className="col">
                  <div className="bg-white shadow-2xl p-3">
                    <div className="row">
                      <div className="col-9 bg-[#f0f2f7] rounded-2 h-full flex justify-center items-center relative">
                        <span className="absolute text-xs top-[-25px] left-0 btn-gradient rounded-full text-white p-1 ">
                          200
                        </span>
                        <Design size={100} chairs={8} chairSize={20} />
                      </div>
                      <div className="col-3 h-full p-2 ">
                        <PlusButton />
                        <MinusButton />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="bg-white shadow-2xl p-3">
                    <div className="row">
                      <div className="col-9 bg-[#f0f2f7] rounded-2 h-full flex justify-center items-center relative">
                        <span className="absolute text-xs top-[-25px] left-0 btn-gradient rounded-full text-white p-1 ">
                          200
                        </span>
                        <Design size={100} chairs={8} chairSize={20} />
                      </div>
                      <div className="col-3 h-full p-2 ">
                        <PlusButton />
                        <MinusButton />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Seating;
